import {DocumentNode, gql} from "@apollo/client";

export const PAYMENT_PUBLIC_QUERY: DocumentNode = gql(`    
    query GetPublicPayment($internalId: String!) {
        getPublicPaymentOperation(internalId: $internalId) {
            ...PaymentPublicInfo
        }
    }
`);
